import React from 'react';
import { Button } from 'react-bootstrap';

const LogoutButton = (props) => (
  <Button {...props}>Logout</Button>
);

export default LogoutButton;



// WEBPACK FOOTER //
// ./src/components/facebook/LogoutButton.jsx